import { Component, OnDestroy, OnInit } from '@angular/core'
import { Subject } from 'rxjs'
import { shareReplay, takeUntil, tap } from 'rxjs/operators'
import { KeyingAuthService } from './services/keying.auth.service'
import { KeyingDataSetsService } from './services/keying.data.sets.service'
import { KeyingStructureService } from './services/keying.structure.service'
import { NotificationPollingService } from './services/notification-polling.service'

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  /* istanbul ignore next */
  destroy$ = new Subject()

  // Expose the observable directly for async pipe
  user$ = this.keyingAuthService.keyingUser$.pipe(
    tap((user) => {
      if (user) {
        // Defer to avoid ExpressionChangedAfterItHasBeenCheckedError
        setTimeout(() => {
          this.keyingDataSetsService.loadKeyingDataSets()
          this.notificationPollingService.start()
        }, 0)
      }
    }),
    shareReplay(1)
  )

  /* istanbul ignore next */
  constructor(
    private keyingAuthService: KeyingAuthService,
    private keyingStructureService: KeyingStructureService,
    private keyingDataSetsService: KeyingDataSetsService,
    private notificationPollingService: NotificationPollingService
  ) {
    this.keyingAuthService.localAuthSetup()
    this.keyingAuthService.handleAuthCallback()
  }

  /* istanbul ignore next */
  ngOnInit(): void {
    // Subscribe to trigger the tap side effect
    this.user$.pipe(takeUntil(this.destroy$)).subscribe()
  }

  /* istanbul ignore next */
  ngOnDestroy() {
    this.keyingStructureService.setStructures(null)
    this.destroy$.next(true)
    this.destroy$.complete()
  }
}
